import FieldModel from './field';

export default class SetModel {
  constructor(code, name, template) {
    this.name = name;
    this.code = code;
    this.fields = [];

    if (!template) {
      throw new Error('Config template not defined');
    }

    template.fields.forEach((templateField) => {
      const field = new FieldModel(templateField.code, null);
      this.fields.push(field.toRecord());
    });
  }

  toRecord() {
    return { code: this.code, name: this.name, fields: this.fields };
  }
}
